import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from './utils';
/** The visual radio circle; the caller owns the input or button around it. */
export default function RadioIndicator({ checked, className, }) {
    return (_jsx("span", { "aria-hidden": "true", className: classNames('relative block size-4 shrink-0 rounded-full', checked ? 'bg-brand-500' : 'border-base-300 bg-card border', className), children: checked && (_jsx("span", { className: "absolute top-1/2 left-1/2 size-1.75 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white" })) }));
}
